module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_8017.3c444b8e.png";